export default __webpack_public_path__ + "static/media/Scorecard.5517c99a.svg";